import $http from "../../helpers/api";

const state = {
    token: localStorage.getItem("access_token") || "",
    isAdmin: false,
    status: "",
    username: "",
    roles: false,
    asf: [],
    currentAsf: null,
    isCanon: false
};

const getters = {
    getIsAdmin: state => state.isAdmin,
    getIsCanon: state => state.isCanon,
    isLoggedIn: state => state.token !== "",
    authStatus: state => state.status,
    getToken: state => state.token,
    getSessionRoles: state => state.roles,
    getAsf: state => state.asf,
    getCurrentAsf: state => state.currentAsf,
    getUsername: state => state.username,
    isInRoles: state => role => {
        var bol = false;
        if (role.includes(",")) {
            role.split(",").forEach(function(element) {
                if (state.roles.indexOf(element) !== -1) {
                    bol = true;
                }
            });
        } else {
            if (state.roles.indexOf(role) !== -1) {
                bol = true;
            }
        }
        return bol;
    }
};

const actions = {
    auth_request({
        commit,
        dispatch
    }, data) {
        return new Promise((resolve, reject) => {
            commit("auth_request");
            $http.post("/login", {
                email: data.email,
                password: data.password
            }).then(resp => {
                const token = resp.data.access_token;

                localStorage.setItem("access_token", token);
                commit("auth_success", token);
                commit("session_user", resp.data.user);
                if (resp.data.user.roles[0].name != "admin") {
                    commit("setCurrentAsf", resp.data.user.asfs[0].id);
                }
                resolve(resp);
            }).catch(err => {
                commit("auth_error", err);
                localStorage.removeItem("access_token");
                reject(err);
            });
        });
    },
    auth_logout({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            commit("auth_logout");
            localStorage.removeItem("access_token");
            resolve();
        });
    },
    getSessionUser({
        commit,
        dispatch
    }, user) {
        return new Promise((resolve, reject) => {
            $http.get("/users/me").then(response => {
                commit("session_user", response.data.user);
                resolve();
            });
        });
    }
};

const mutations = {
    setCurrentAsf(state, asf) {
        state.currentAsf = asf;
    },
    auth_request(state) {
        state.status = "loading";
    },
    auth_success(state, token) {
        state.status = "success";
        state.token = token;
    },
    auth_error(state) {
        state.status = "error";
    },
    auth_logout(state) {
        state.status = "";
        state.token = "";
        state.username = "";
        state.roles = false;
    },
    session_user(state, user) {
        state.username = user.name;
        state.roles = user.roles.map(o => o["name"]);
        state.asf = user.asfs[0];
        state.currentAsf = user.roles[0].name == "admin" ?
            null :
            user.asfs[0].id;
        state.isCanon = user.asfs[0].super_asf;
        // check if is admin of Canon
        let roles = state.roles.filter(role => {
            return role === "admin";
        });
        state.isAdmin = roles.length > 0 && state.isCanon;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
